import { Button } from '@unmind/design-system-components-web';
import { rem } from 'polished';
import { css, styled } from 'styles';

export const ErrorButton = styled(Button)<{
  $orientation?: 'vertical' | 'horizontal';
}>`
  ${({ $orientation }) =>
    $orientation === 'vertical'
      ? css`
          margin-top: ${rem(12)};
        `
      : css`
          margin-left: auto;
        `}
  border-radius: ${rem(24)};
  background-color: ${({ theme }) => theme.colors.background.input};
  &:hover {
    background-color: ${({ theme }) => theme.colors.background.input};
  }
`;
